import React from 'react';
import { ActivityItem } from '../taxComplianceTypes';
import styles from './ComplianceActivityFeed.module.css';

interface ComplianceActivityFeedProps {
  items: ActivityItem[];
}

export const ComplianceActivityFeed: React.FC<ComplianceActivityFeedProps> = ({ items }) => {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>Recent Compliance Activity</h3>
      <div className={styles.feed}>
        {items.map((item, idx) => (
          <div key={idx} className={styles.item}>
            <div className={styles.timelineCol}>
              <span className={styles.dot} style={{ background: item.dotColor }} />
              {idx < items.length - 1 && <span className={styles.line} />}
            </div>
            <div className={styles.content}>
              <p className={styles.itemTitle}>{item.title}</p>
              <p className={styles.itemDesc}>{item.description}</p>
              <p className={styles.itemMeta}>
                <span>{item.timestamp}</span>
                <span className={styles.metaDot}>·</span>
                <span className={styles.source}>{item.source}</span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
